/**
 * Quick course check for testing
 */

import { getCourseById } from '../services/courseService';

export async function quickCourseCheck() {
  // Both courses we've been working with
  const AUGUST_COURSE = '045ef510-0d3d-41f7-808e-e75a77cb765c'; // AugustShort2025
  const JULY_COURSE = '296faed7-a5f5-4c1f-9e1b-38dd3623c4a0';   // July 30
  
  console.log('🔍 QUICK COURSE STATUS CHECK');
  console.log('=' .repeat(50));
  
  try {
    // Check August course
    console.log('\n1️⃣ AugustShort2025 Course:');
    const august = await getCourseById(AUGUST_COURSE);
    console.log('  ID:', AUGUST_COURSE);
    console.log('  Status:', august.status);
    console.log('  Total spots:', august.totalSpots);
    console.log('  Available:', august.availableSpots);
    console.log('  Ready for testing?', august.status === 'published' && august.availableSpots > 0);
    
    // Check July course
    console.log('\n2️⃣ July 30 Course:');
    const july = await getCourseById(JULY_COURSE);
    console.log('  ID:', JULY_COURSE);
    console.log('  Status:', july.status);
    console.log('  Total spots:', july.totalSpots);
    console.log('  Available:', july.availableSpots);
    console.log('  Ready for testing?', july.status === 'published' && july.availableSpots <= july.totalSpots);
    
    console.log('\n📋 RECOMMENDATIONS:');
    
    if (august.status !== 'published') {
      console.log('❌ AugustShort2025 needs to be published:');
      console.log('   Run: bash scripts/fix-august-course.sh');
    }
    
    if (july.availableSpots > july.totalSpots) {
      console.log('❌ July 30 has corrupted capacity:');
      console.log('   Run: bash scripts/fix-july-course.sh');
    }
    
    if (august.status === 'published' && august.availableSpots > 0) {
      console.log('✅ AugustShort2025 is ready for testing!');
      console.log('   Use ID:', AUGUST_COURSE);
    }
    
    if (july.status === 'published' && july.availableSpots <= july.totalSpots && july.availableSpots > 0) {
      console.log('✅ July 30 is ready for testing!');
      console.log('   Use ID:', JULY_COURSE);
    }
    
    return { august, july };
    
  } catch (error) {
    console.error('Check failed:', error);
  }
}

window.quickCourseCheck = quickCourseCheck;